module.exports = __webpack_public_path__ + "static/media/checkout-local-delivery-active.dab6c156.svg";